module.exports = __webpack_public_path__ + "media/images/tennis-overhead-57217285.jpg";